import SampleLayoutAuth from "./layouts/layout-auth.vue";
import SampleLayoutMain from "./layouts/layout-main.vue";
import { security } from "./middlewares";

export default [
  {
    path: "/sample",
    component: SampleLayoutMain,
    children: [
      {
        path: "",
        name: "sample_home",
        component: () => import(/* webpackChunkName: "sample-home" */ "@/domains/sample/views/home.vue"),
        meta: {
          middleware: [security],
        },
      },
      {
        path: "/sample/customers",
        name: "sample_customers",
        component: () => import(/* webpackChunkName: "sample-customers" */ "@/domains/sample/views/customers.vue"),
        meta: {
          middleware: [security],
          title: 'Clientes',
          tab: true,
        },
      },
      {
        path: "/sample/contacts",
        name: "sample_contacts",
        component: () => import(/* webpackChunkName: "sample-contacts" */ "@/domains/sample/views/contacts.vue"),
        meta: {
          middleware: [security],
          title: 'Contatos',
          tab: true,
        },
      },
      {
        path: "/sample/banks",
        name: "sample_banks",
        component: () => import(/* webpackChunkName: "sample-banks" */ "@/domains/sample/views/banks.vue"),
        meta: {
          middleware: [security],
          title: 'Bancos',
          tab: true,
        },
      },
      {
        path: "/sample/financial",
        name: "sample_financial",
        component: () => import(/* webpackChunkName: "sample-financial" */ "@/domains/sample/views/financial.vue"),
        meta: {
          middleware: [security],
          title: 'Financeiro',
          tab: true,
        },
      },
      {
        path: "/sample/reports",
        name: "sample_reports",
        component: () => import(/* webpackChunkName: "sample-reports" */ "@/domains/sample/views/reports.vue"),
        meta: {
          middleware: [security],
          title: 'Relatórios',
          tab: true,
        },
      },
    ],
  },
  {
    path: "/sample",
    component: SampleLayoutAuth,
    children: [
      {
        path: "login",
        name: "sample_login",
        component: () => import(/* webpackChunkName: "sample-login" */ "@/domains/sample/views/login.vue"),
        meta: {
          middleware: [],
        },
      },
    ],
  },
];
